/**
 * PDP performance: hydrate deferred gallery slides before carousel init.
 * - Flickity PDP (product.liquid): [data-defer-gallery] + template[data-product-gallery-defer]
 * - Zinus Swiper PDP (zinus-product.liquid): [data-defer-zinus-gallery] + template[data-zinus-gallery-defer]
 */
(function () {
  function lazySizesCheck() {
    try {
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.checkElems();
      }
    } catch (_) {}
  }

  function hydrateFlickityGalleries() {
    document.querySelectorAll('[data-defer-gallery]').forEach(function (group) {
      var template = group.querySelector('template[data-product-gallery-defer]');
      var slider = group.querySelector('[data-product-single-media-slider]');
      if (!template || !slider) {
        group.removeAttribute('data-defer-gallery');
        return;
      }

      slider.appendChild(template.content.cloneNode(true));
      template.remove();
      group.removeAttribute('data-defer-gallery');
      lazySizesCheck();
    });
  }

  function hydrateZinusGalleries() {
    var hydrated = false;
    document.querySelectorAll('[data-defer-zinus-gallery]').forEach(function (group) {
      var template = group.querySelector('template[data-zinus-gallery-defer]');
      var wrapper = group.querySelector('.gallery-top .swiper-wrapper');
      if (!template || !wrapper) {
        group.removeAttribute('data-defer-zinus-gallery');
        return;
      }

      wrapper.appendChild(template.content.cloneNode(true));
      template.remove();
      group.removeAttribute('data-defer-zinus-gallery');
      hydrated = true;
      lazySizesCheck();
    });

    if (hydrated) {
      try {
        document.dispatchEvent(new Event('zinus:gallery:hydrated'));
      } catch (_) {}
    }
  }

  function hydrateAllFlickityNow() {
    hydrateFlickityGalleries();
  }

  function hydrateAll() {
    hydrateFlickityGalleries();
    hydrateZinusGalleries();
  }

  function scheduleZinusHydration() {
    if (!document.querySelector('[data-defer-zinus-gallery]')) return;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(hydrateZinusGalleries, { timeout: 2500 });
    } else {
      window.setTimeout(hydrateZinusGalleries, 400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        hydrateAllFlickityNow();
        scheduleZinusHydration();
      },
      { once: true }
    );
  } else {
    hydrateAllFlickityNow();
    scheduleZinusHydration();
  }

  document.addEventListener(
    'click',
    function (ev) {
      var needsFlickity =
        document.querySelector('[data-defer-gallery]') &&
        ev.target.closest('[data-thumbnail-id], .product-single__thumbnail-link');
      var needsZinus =
        document.querySelector('[data-defer-zinus-gallery]') &&
        ev.target.closest(
          '[data-thumbnail-id], .product-single__thumbnail-link, .gallery-thumbs .swiper-slide'
        );

      if (!needsFlickity && !needsZinus) return;
      if (!ev.target.closest('[data-product-single-media-group]')) return;

      if (needsFlickity) hydrateFlickityGalleries();
      if (needsZinus) hydrateZinusGalleries();
    },
    true
  );

  window.zinusHydrateDeferredGallery = hydrateAll;
})();
